import { createContext, useContext } from 'react';

/**
 * Whether the app's sidebar is collapsed to icons (wide screens only; on a phone it is a drawer and this is
 * false). A page's own section list (AdminSectionNav) follows it, so one button narrows both.
 */
const SidebarContext = createContext({ collapsed: false });

export const useSidebar = () => useContext(SidebarContext);

export default SidebarContext;
